export default __webpack_public_path__ + "static/media/Img0003.92ccac3f.png";